// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__27tRx","description":"PatientConsentPreview_description__1t6Ps"};